import { ApplePayButtonLogo } from '@/components/Wallets/WalletButton/ApplePayButtonLogo';
import '@/components/Wallets/WalletButton/walletButton.css';

/**
 * Clickable twin of `ApplePayButtonPlaceholder` (same black pill + white
 *  Pay glyph via `wallet-visual-button`), used where the real Apple Pay
 * button can never render (iOS <= 16 cross-origin iframe). The click opens
 * the checkout in a top-level tab — see `ApplePayTabFallback`.
 */
export const FakeApplePayButton = ({ onClick }: { onClick: () => void }): JSX.Element => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Apple Pay"
    data-testid="fake-apple-pay-button"
    className="wallet-visual-button w-full rounded-lg bg-black cursor-pointer"
  >
    <ApplePayButtonLogo />
  </button>
);
